export default __webpack_public_path__ + "static/media/katalon.54e27d7a.png";